<template>
  <div :class="$style.container">
    <div :class="$style.top">
      <app-button type="border" @click="$router.go(-1)" icon="ArrowLeftIcon">Вернуться к заявкам</app-button>
      <div :class="$style.actions">
        <app-button v-if="canChangeManager" @click="onChangeManager" type="border" :class="$style.action">
          Изменить исполнителя
        </app-button>
        <app-button v-if="canChangeCategory" @click="onChangeType" type="border" :class="$style.action">
          Изменить тип
        </app-button>
        <app-button v-if="canCancel" @click="onCancel" type="border" :class="$style.action">
          Отклонить заявку
        </app-button>
      </div>
    </div>

    <div :class="$style.head">
      <div :class="$style.badge" :style="{'--color': status.color}">
        Заявка <b>№{{ issue.id }}</b> от <b>{{ formatDate(issue.created_at, 'dd.MM.yyyy HH:mm:ss') }}</b>
      </div>
      <app-icon :class="$style.titleIcon" name="ApartmentIcon" size="42px" />
      <div :class="$style.title">
        {{ address }}
        <div :class="$style.city">г. {{ issue.building.city }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate          from "@/client/helpers/formatDate";
import generateFullAddress from "@/functions/generateFullAddress";
import {
  ISSUE_STATUS_ASSIGNED,
  ISSUE_STATUS_CANCELLED,
  ISSUE_STATUS_COMPLETE,
  ISSUE_STATUS_WORK,
}                          from "@/constants/issues";
import parseJSON           from "@/utils/parseJSON";

export default {
  name:     "IssueHeader",
  props:    ['issue', 'onUpdate'],
  computed: {
    address() {
      return generateFullAddress(this.issue.apart, this.issue.building, { withoutCity: true });
    },
    status() {
      return this.$store.getters['common/tasks/statusById'](this.issue.status_id);
    },
    currentUserId() {
      return this.$store.getters['appUser/id'];
    },
    isCurrentUserAdmin() {
      const { issue } = this;
      return this.$can('issues.admin', 'access', issue.buildings_id);
    },
    canCancel() {
      const { issue, currentUserId } = this;
      return issue.status_id !== ISSUE_STATUS_CANCELLED
        && issue.status_id !== ISSUE_STATUS_COMPLETE
        && (
          issue.performer_id === currentUserId ||
          issue.manager_id === currentUserId ||
          this.isCurrentUserAdmin
        );
    },
    canChangeManager() {
      const { issue, currentUserId } = this;

      return (issue.manager_id === currentUserId || this.isCurrentUserAdmin) &&
        (
          issue.status_id === ISSUE_STATUS_ASSIGNED ||
          issue.status_id === ISSUE_STATUS_WORK
        );
    },
    canChangeCategory() {
      const { issue, currentUserId } = this;
      return (issue.manager_id === currentUserId || issue.performer_id === currentUserId || this.isCurrentUserAdmin) &&
        issue.status_id !== ISSUE_STATUS_CANCELLED &&
        issue.status_id !== ISSUE_STATUS_COMPLETE
        ;
    },
  },
  methods:  {
    formatDate,

    onChangeManager() {
      this.$modal.open({
        size:           'md',
        title:          'Сменить исполнителя',
        component:      () => import('@/components/common/issues/IssueChangeManagerModal'),
        componentProps: {
          issue:           this.issue,
          onChangeManager: ( performer_id ) => {
            return this.onUpdate({ performer_id });
          },
        },
      });
    },

    onChangeType() {
      this.$modal.open({
        size:           'xs',
        title:          'Сменить тип',
        component:      () => import('@/components/common/issues/IssueChangeCategoryModal'),
        componentProps: {
          issue:            this.issue,
          onChangeCategory: ( category_id ) => {
            return this.onUpdate({ category_id });
          },
        },
      });
    },

    onCancel() {
      this.$modal.open({
        size:           'xs',
        title:          'Отклонить заявку',
        component:      () => import('@/components/common/issues/IssueCancelModal'),
        componentProps: {
          issue:    this.issue,
          onCancel: ( reason ) => {
            const additional = parseJSON(this.issue.additional) || {};
            additional.cancelReason = reason;
            return this.onUpdate({ status_id: ISSUE_STATUS_CANCELLED, additional: JSON.stringify(additional) });
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  //height: 100%;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  max-height: 55px;
  margin-bottom: 20px;
}

.action {
  margin-left: .5em;
}

.head {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 2;
  max-height: 85px;
  //margin-bottom: 50px;
}

.badge {
  position: relative;
  font-size: 1.25rem;
  color: #ffffff;
  line-height: 42px;
  background: var(--color, (0, 0, 0));
  margin-left: -20px;
  padding: 0 20px;
  margin-right: 20px;
  flex-shrink: 0;
  @include anim();

  b {
    font-weight: 600;
  }

  &:before, &:after {
    content: '';
    position: absolute;
    left: 100%;
    width: 0;
    height: 0;
    border-style: solid;
  }

  &:before {
    top: 0;
    border-width: 21px 10px 0 0;
    border-color: var(--color, (0, 0, 0)) transparent transparent transparent;
  }

  &:after {
    bottom: 0;
    border-width: 21px 0 0 10px;
    border-color: transparent transparent transparent var(--color, (0, 0, 0));
  }
}

.titleIcon {
  flex-shrink: 0;
  margin-right: 10px;
}

.title {
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1;
  margin-top: .2rem;
}

.city {
  margin-top: .3em;
  font-size: 1rem;
  font-weight: 500;
}

</style>
